/**
 * Enum che rappresenta il tipo di cliente (Company).
 * Allineato con il valore `Type` dell'entità CompanyType sul backend.
 *
 * TODO: Valutare di derivarlo direttamente dall'enum di CompanyType
 *       una volta che sarà disponibile un namespace condiviso.
 */
export enum CustomerTypeEnum {
  DEFAULT  = 0,
  PRIVATE  = 1,
  BUSINESS = 2
}
